/* eslint-disable lingui/no-unlocalized-strings -- Brand names are not translated. */
import { cn } from "@reactive-resume/utils";
import { useLocation } from "react-router-dom";

import { FIRST_ROUND_BRAND_PARAM } from "@/client/utils/firstRoundAppUrl";

const STORAGE_KEY = "auth-brand";

/** Remember for this tab that the visitor came through First Round (e.g. the demo feedback). */
export const rememberFirstRoundBrand = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, FIRST_ROUND_BRAND_PARAM);
  } catch {
    // Storage blocked: the brand simply isn't remembered.
  }
};

/**
 * True when the visitor arrived from the First Round marketing site. CTAs on firstround.com.au
 * add ?brand=firstround to sign-in / sign-up links (see toFirstRoundAppUrl). The answer is kept
 * for the tab's session because Clerk's multi-step flows can drop the query string.
 *
 * The sign-in screen is the seam between the two brands: it wears the First Round mark and story
 * for these visitors, and stays theResume's for everyone else. Nothing past sign-in changes —
 * inside the product theResume is the honest name.
 */
export const useIsFirstRoundBrand = (): boolean => {
  const { search } = useLocation();
  const fromQuery = new URLSearchParams(search).get("brand");
  try {
    if (fromQuery === FIRST_ROUND_BRAND_PARAM) sessionStorage.setItem(STORAGE_KEY, fromQuery);
    return sessionStorage.getItem(STORAGE_KEY) === FIRST_ROUND_BRAND_PARAM;
  } catch {
    return fromQuery === FIRST_ROUND_BRAND_PARAM;
  }
};

/**
 * The one line that explains the change of name, shown under the First Round mark. The mark
 * itself carries the brand, so this stays deliberately quiet — saying "First Round" twice on one
 * screen is what made the handover read as a redirect to somewhere else.
 */
export const PoweredByTheResume = ({ className }: { className?: string }) => (
  <p className={cn("text-xs text-slate-500", className)}>powered by theResume</p>
);
